import { CoordinatorService } from './coordinator.service';
import { KeywordGroup } from './keyword-group';
import { ScriptBase } from './script-base';

export class ScriptKeywordGroup extends ScriptBase {
    #coords: CoordinatorService;
    #_keywordGroup: KeywordGroup;

    constructor(coords: CoordinatorService, _keywordGroup: KeywordGroup) {
        super(coords, _keywordGroup);
        this.#coords = coords;
        this.#_keywordGroup = _keywordGroup;
    }

    log() {
        console.log('KeywordGroup:', this.#_keywordGroup.id, this.#_keywordGroup.title);
    }

    hitset(isPreview = false) {
        const nH = this.#coords.script$.hitset(isPreview);
               const s = new Set<string>();
        this.#_keywordGroup.keywordLs.forEach((kw) =>
            kw.scriptClass.hitset(isPreview).idSet.forEach((x) => s.add(x)),
        );
        return this._hitset(nH, s, isPreview);
    }
}
